import React from 'react';
import './CustomLofaButton.scss';
import { LofaScheduleEditState } from '../../../store/types';

interface CustomLofaButtonProps {
    isBordered?: boolean;
    title: string;
    onClick: () => void;
    validate?: LofaScheduleEditState;
    disabled?: boolean;
}

export const CustomLofaButton = ({
    title,
    isBordered = false,
    onClick,
    validate,
    disabled,
}: CustomLofaButtonProps): React.ReactElement => {
    let disable = true;
    if (validate && validate !== undefined && validate.toBePosted) {
        validate.toBePosted.map(item => {
            if (item) {
                disable = !(
                    item.proppantId !== 0 &&
                    item.proppantName !== '' &&
                    item.jobSummaries &&
                    item.jobSummaries.map(it => {
                        if (it) {
                            disable = !(
                                it.lofaVolume !== 0 &&
                                it.volumePerBox !== null &&
                                it.volumePerBox !== undefined &&
                                it.volumePerBox > 0 &&
                                it.milesFromWell !== null &&
                                it.milesFromWell !== undefined &&
                                it.milesFromWell > 0 &&
                                it.sandPo != '' &&
                                it.lofaName != ''
                            );
                        } else {
                            disable = true;
                        }
                    })
                );
            } else {
                disable = true;
            }
        });
    }
    if (validate === undefined) {
        disable = false;
    }

    return (
        <button
            disabled={disabled || disable}
            className={`CustomLofaButton-Default ${
                isBordered ? 'CustomLofaButton-Bordered' : 'CustomLofaButton-Plain'
            }`}
            onClick={onClick}
        >
            {title}
        </button>
    );
};
